import React from 'react'

const DefaultAvatar = (props) => {
    return (
        <img src={props.selected ? "/assets/icons/default-avatar.svg" : "/assets/icons/default-avatar.svg"}
             alt="Avatar"
             style={props.style}
        />
    )
}

export default DefaultAvatar